export interface ICopyFooter {
  year: number;
  appVersion: string;
}

export const copyFooterData: ICopyFooter = {
  year: new Date().getFullYear(),
  appVersion: import.meta.env.PUBLIC_ENV__REACT_APP_VERSION,
};
